import { components as antdComponents } from '@yimoka/antd';
import { components as reactComponents } from '@yimoka/react';

import { SafeHTMLContent } from './safe-html-content';

/** realmHomeRuntimeComponents 复用 Yimoka 两个基础 registry，并只覆盖公开页面必须加固的富文本边界。 */
export const realmHomeRuntimeComponents = {
  ...reactComponents,
  ...antdComponents,
  HTMLContent: SafeHTMLContent,
};
